module.exports = __webpack_public_path__ + "static/img/ability-img3.662873d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/weicai/weTech/ability-img3.png
// module id = 0rm7
// module chunks = 2